<div class="row missing-geo" *ngIf="(missingGeoLocation$ | async) === true">
  <div class="col col-xs-12">
    <glxy-alert type="warning">
      <div
        [innerHTML]="'LOCAL_SEO.LOCAL_SEO.GEO_NOT_SET' | translate: { redirectLink: listingProfileRedirectLink }"
      ></div>
    </glxy-alert>
  </div>
</div>
<div>
  @if (showTwitterReconnectBanner$ | async) {
    <glxy-alert class="reconnect-alert" type="warning">
      <strong>{{ 'COMMON.TWITTER_RECONNECT' | translate }}</strong>
      &mdash; {{ 'COMMON.TWITTER_BANNER_RECONNECT_MESSAGE' | translate }}
    </glxy-alert>
  }
  @if (listingScoreUnavailable$ | async) {
    <glxy-alert *ngIf="listingScoreUnavailable$ | async" class="reconnect-alert" type="warning">
      {{ 'COMMON.LISTING_SCORE_UNAVAILABLE' | translate }}
    </glxy-alert>
  }
  @if (listingSyncUnavailable$ | async) {
    <glxy-alert class="reconnect-alert" type="warning">
      {{ 'COMMON.LISTING_SYNC_UNAVAILABLE' | translate }}
    </glxy-alert>
  }
  @if (showFacebookReconnectBanner$ | async) {
    <glxy-alert class="reconnect-alert" type="warning">
      @if (isSmActive$ | async) {
        <strong>{{ 'COMMON.RECONNECT_FACEBOOK.TITLE' | translate }}</strong>
        &mdash;
        <span
          [innerHTML]="
            'COMMON.RECONNECT_FACEBOOK.WITH_SM_DESCRIPTION'
              | translate
                : { businessAppReconnectLink: businessAppReconnectLink, businessAppCustomName: businessAppCustomName }
          "
        ></span>
      } @else {
        <strong>{{ 'COMMON.RECONNECT_FACEBOOK.TITLE' | translate }}</strong>
        &mdash; {{ 'COMMON.RECONNECT_FACEBOOK.NO_SM_DESCRIPTION' | translate }}
      }
    </glxy-alert>
  }

  @if (hasCategoryNotFound) {
    <glxy-alert class="reconnect-alert" type="warning">
      <div [innerHTML]="'COMMON.HAS_CATEGORY_NOT_FOUND_MESSAGE' | translate: { redirectLink: redirectLink }"></div>
    </glxy-alert>
  }

  <div class="row">
    <div class="col col-xs-12 col-sm-12 col-md-6">
      <mat-card class="listings-nap-map-card">
        <ng-container>
          <mat-card-header class="syncing-progress-summary-card-title">
            <mat-card-title>
              {{ 'LISTING_SYNC.YOUR_BUSINESS_PROFILE' | translate }}
            </mat-card-title>
          </mat-card-header>
          <local-seo-listing-nap-map-card size="Small" [overlay]="'half'"></local-seo-listing-nap-map-card>
        </ng-container>
      </mat-card>
    </div>
    <div class="col col-xs-12 col-sm-12 col-md-6">
      <local-seo-syncing-progress-summary-card class="synced-summary-card"></local-seo-syncing-progress-summary-card>
    </div>
  </div>

  <div class="row row-gutters">
    <div class="col col-xs-12">
      <div class="title">{{ 'LISTING_SYNC.PRIMARY_SOURCES.TITLE' | translate }}</div>
      <p>{{ 'LISTING_SYNC.PRIMARY_SOURCES.SUBTITLE' | translate }}</p>
      <local-seo-primary-sources [isListingfromEmbedded]="isListingfromEmbedded"></local-seo-primary-sources>
    </div>
  </div>

  @if ((lspUpgradeHidden$ | async) === false) {
    <div class="row row-gutters">
      <div class="col col-xs-12">
        <div class="title">{{ 'LISTING_SYNC.ADDITIONAL_SOURCES.TITLE' | translate }}</div>
        <p>{{ 'LISTING_SYNC.ADDITIONAL_SOURCES.SUBTITLE' | translate }}</p>
        <local-seo-listing-sync-table [isListingfromEmbedded]="isListingfromEmbedded"></local-seo-listing-sync-table>
      </div>
    </div>
  }
</div>
